<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page_vii"></a>‘Infinite riches in a little room’</p>
<p class="dedi1"><em class="italic">Christopher Marlowe</em></p>
<a id="page_viii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Dedi.vue?57639038